import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from './cn.js';
const tonlar = {
    marka: 'bg-marka-100 text-marka-800 dark:bg-marka-900/40 dark:text-marka-300',
    fume: 'bg-fume-100 text-fume-800 dark:bg-fume-800 dark:text-fume-100',
    yesil: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
    kirmizi: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
    mavi: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300',
    turuncu: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
    gri: 'bg-fume-100 text-fume-600 dark:bg-fume-800/60 dark:text-fume-400',
};
export function Rozet({ ton = 'fume', nokta = false, className, children, ...rest }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium', tonlar[ton], className), ...rest, children: [nokta && _jsx("span", { className: "h-1.5 w-1.5 rounded-full bg-current opacity-80", "aria-hidden": true }), children] }));
}
//# sourceMappingURL=rozet.js.map